import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

const LeadContext = createContext(null);

export const useLead = () => {
  const ctx = useContext(LeadContext);
  if (!ctx) throw new Error("useLead must be used within LeadProvider");
  return ctx;
};

export const LeadProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  const [unlocked, setUnlocked] = useState(
    () => typeof window !== "undefined" && localStorage.getItem("dm_demo_unlocked") === "1"
  );
  const [leadInfo, setLeadInfo] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("dm_lead_info") || "null");
    } catch {
      return null;
    }
  });

  const openLeadForm = useCallback((data = {}) => {
    setPrefill(data);
    setOpen(true);
  }, []);

  const closeLeadForm = useCallback(() => setOpen(false), []);

  const markUnlocked = useCallback((info) => {
    setUnlocked(true);
    setLeadInfo(info);
    localStorage.setItem("dm_demo_unlocked", "1");
    localStorage.setItem("dm_lead_info", JSON.stringify(info));
  }, []);

  const value = useMemo(
    () => ({ open, setOpen, prefill, openLeadForm, closeLeadForm, unlocked, leadInfo, markUnlocked }),
    [open, prefill, openLeadForm, closeLeadForm, unlocked, leadInfo, markUnlocked]
  );

  return <LeadContext.Provider value={value}>{children}</LeadContext.Provider>;
};
